import { RQParam, RQHandlers, RQService, RQApp } from '../RQuery/RQuery';
import { Injectable }                            from '@angular/core';
import { URLSearchParams }                       from '@angular/http';

export class mlBroker {
    Service: MLText;
    View:    dmView;

    constructor(pService: MLText ,pView: dmView) {
        this.Service = pService;
        this.View    = pView;
    }

    public Text(pKey: string, pEn?: string): string {
        let text: string = '';

        if ((!this.View.IsLoaded) || (!this.View.ViewTexts[this.Service.LangID])) {
            throw 'ml broker - view not loaded: ' + this.View.ViewName;
        }

        if (!this.View.ViewTexts[this.Service.LangID][pKey]) {
            text = 'ML-MISSING';
        } else {
            text = this.View.ViewTexts[this.Service.LangID][pKey];
        }

        if (
            (text == 'TRANS')
        &&  (!RQApp.PageParams.Debug)
        &&  (this.View.ViewTexts[1])
        ) {
            text = this.View.ViewTexts[1][pKey]
        }

        return text;
    }
}

class dmView {
    ViewID:    number;
    ViewName:  string;
    ViewTexts: string[][];
    IsLoaded:  boolean;

    constructor(pViewID: number, pViewName: string) {
        this.ViewID    = pViewID;
        this.ViewName  = pViewName;
        this.ViewTexts = [];
        this.IsLoaded  = false;
    }
}

@Injectable()
export class MLText {
    LangID:        number;
    Initialised:   boolean;

    Views:         dmView[];
    ActiveViews:   string[];

    ViewParams     = RQParam.PmsGetMLViewsParams();
    ViewTextParams = RQParam.PmsGetMLViewTextsParams();

    AppTextView:   string;
    RootPageView:  string;

    LangCodeByID:  string[];

    constructor() {
        console.log('initialising ml service');

        this.LangCodeByID = [];

        this.LangCodeByID[1]  = 'en';
        this.LangCodeByID[2]  = 'fr';
        this.LangCodeByID[3]  = 'de';
        this.LangCodeByID[4]  = 'it';
        this.LangCodeByID[5]  = 'es';
        this.LangCodeByID[6]  = 'pt';
        this.LangCodeByID[7]  = 'tr';
        this.LangCodeByID[8]  = 'hu';
        this.LangCodeByID[9]  = 'nl';
        this.LangCodeByID[10] = 'zh';

        this.LangID       = 1;

        /* external params are guarunteed sane if present via server-side C# */
        let params      = new URLSearchParams(window.location.search.substr(1));
        let paramLangID = params.get('LangID');

        if (paramLangID) {
            this.LangID = Number(paramLangID);
        }

        this.Initialised  = false;

        this.Views        = [];
        this.ActiveViews  = [];

        this.AppTextView  = '';
        this.RootPageView = '';

        this.ViewTextParams.CollectionID = 1;

        this.setViewHandler();
        this.setViewTextHandler();
    }

    private setViewHandler(): void {
        RQHandlers.Pms.GetMLViews = (result) => {
            let response = result as any;

            if (response.HasErrorOrException) { throw 'ml service - error loading view stubs'; }

            let views  = response.RQueryResult;

            this.Views = [];

            for (let i = 0; i < views.length; i++) {
                let viewRow = RQService.Pms.PopulateGetMLViewsRow(
                    views[i]
                );

                console.log('row push');

                this.Views[viewRow.FormName] = new dmView(
                     viewRow.FormID
                    ,viewRow.FormName
                );
            }
        };
    }

    private setViewTextHandler(): void {
        RQHandlers.Pms.GetMLViewTexts = (result) => {
            let response = result as any;

            if (response.HasErrorOrException) { throw 'ml service - error loading view texts'; }

            let viewTexts = response.RQueryResult;

            let langID:   number  = 0;
            let gotView:  boolean = false;

            let view: dmView;

            for (let i = 0; i < viewTexts.length; i++) {
                let viewTextRow = RQService.Pms.PopulateGetMLViewTextsRow(
                    viewTexts[i]
                );

                console.log('row push');

                if (!gotView) {
                    langID   = viewTextRow.LangID;
                    gotView  = true;

                    view     = this.Views[viewTextRow.FormName];
                }

                view.ViewTexts[langID][viewTextRow.MLTextName] = viewTextRow.Translation;
            }
        };
    }

    private getViews(pResolve: () => void): void {
        RQService.Pms.GetMLViews(this.ViewParams).then((result) => {
            pResolve();
        });
    }

    private getViewTexts(pView: dmView ,pLangID: number ,pResolve: () => void) {
        pView.ViewTexts[pLangID]         = [];

        this.ViewTextParams.FormID       = pView.ViewID;
        this.ViewTextParams.LangID       = pLangID;
        this.ViewTextParams.MissingOnly  = 0;
        this.ViewTextParams.WithFallback = (RQApp.PageParams.Debug) ? 0 : 1;
      
      console.log("pView.ViewID");
      console.log(pView.ViewID);
        RQService.Pms.GetMLViewTexts(this.ViewTextParams).then((result) => {
            pResolve();
        });
    }

    private reloadViews(pLangID: number ,pResolve: () => void): void {
        let key: string = this.ActiveViews.pop();

        if (key) {
            this.LoadView(pLangID, key, () => {
                this.reloadViews(pLangID, pResolve);

                return;
            });
        } else {
            pResolve();

            return;
        }
    }

    public InitLangID(pLangID: number): void {
        if (this.LangCodeByID[pLangID]) {
            this.LangID = pLangID;
        } else {
            this.LangID = 1;
        }
    }

    public GetLangID(): number {
        return this.LangID;
    }

    public GetLangCode(): string {
        if (!this.LangCodeByID[this.LangID]) {
            return 'en';
        } else {
            return this.LangCodeByID[this.LangID];
        }
    }

    public ChangeLanguage(pLangID: number ,pResolve: () => void): void {
        this.ActiveViews = [];

        for (let key in this.Views) {
            if (this.Views[key].IsLoaded) { this.ActiveViews.push(key); }
        }

        this.reloadViews(pLangID, () => {
            this.LangID = pLangID;

            pResolve();
        });
    }

    public InitialiseService(
         pAppTextView:  string
        ,pRootPageView: string
        ,pResolve:      () => void
    ): void {
        if (this.Initialised) { pResolve(); return; }

        this.AppTextView  = pAppTextView;
        this.RootPageView = pRootPageView;

        this.getViews(() => {
            this.LoadView(this.LangID ,this.AppTextView ,() => {
                this.LoadView(this.LangID ,this.RootPageView ,() => {
                    this.Initialised = true;

                    pResolve();

                    return;
                });

                return;
            });

            return;
        });
    }

    public LoadView(pLangID: number ,pViewName: string ,pResolve: () => void) {
        if (RQApp.IsPageContext) { pResolve(); return; }

        if (!this.Views[pViewName]) {
            throw 'ml service - no such view: ' + pViewName;
        }

        let view: dmView = this.Views[pViewName];

        if (view.IsLoaded && view.ViewTexts[pLangID]) { pResolve(); return; }

        if ((!view.IsLoaded) || (!view.ViewTexts[pLangID])) {
            this.getViewTexts(
                 view
                ,pLangID
                ,() => {
                    view.IsLoaded = true;

                    pResolve();

                    return;
                }
            );
        }
    }

    public GetBroker(pViewName: string): mlBroker {
        if (!this.Views[pViewName]) {
            throw 'ml service - no such view: ' + pViewName;
        }

        return new mlBroker(this, this.Views[pViewName]);
    }

    public IsViewLangLoaded(pViewName: string ,pLangID: number): boolean {
        if (!this.Views[pViewName]) {
            throw 'ml service - no such view: ' + pViewName;
        }

        let view: dmView = this.Views[pViewName];

        if (
            (!view.IsLoaded)
        ||  (!view.ViewTexts[pLangID])
        ) { return false; }

        return true;
    }

    public RegisterView(pViewID: number ,pViewName: string): void {
        this.Views[pViewName] = new dmView(
             pViewID
            ,pViewName
        );
    }

    public RegisterViewText(
         pViewName:    string
        ,pMLTextName:  string
        ,pTranslation: string
        ,pLangID:      number
    ): void {
        if (!this.Views[pViewName]) {
            throw 'ml service - no such view: ' + pViewName;
        }

        let view: dmView = this.Views[pViewName];

        if (!view.ViewTexts[pLangID]) { view.ViewTexts[pLangID] = [];   }
        if (!view.IsLoaded)           { view.IsLoaded           = true; }

        view.ViewTexts[pLangID][pMLTextName] = pTranslation;
    }
}


// WEBPACK FOOTER //
// ./src/services/MLText.ts